
import {SafeStyle} from "@angular/platform-browser";
import {NbStyle} from "./nb-style.directive";
import {Input} from "@angular/core";

export interface NbMassiveItem {
  // deprecated
  id?: any;
  label?: string;
  title?:string;
  name?: string;

  // new
  text: string;
  value: any;
  checked?:boolean;
  icon?:string;
  css?: string|string[];
  styles?:NbStyle;
  hideon?:string;
}

export class NbinputConfig {
  uploadAPI?:string = '';
  downloadAPI?:string = '';
  renameAPI?:string = '';
  token?:string = '';
  format?:string = '';
  valueMode?:string = '';
}

export class NbFile extends File{
  completed: boolean;
  success: boolean;
  progressStyle: SafeStyle;
  progress: number;
  errMsg: string;
  url: string;
  id: number;

  ConvertToAttachment():SystemAttachment{
    let a = new SystemAttachment();
    a.url = this.url;
    a.id = this.id;
    a.progress = this.progress;
    a.success = this.success;
    a.completed = this.completed;
    a.size = this.size;
    a.name = this.name;
    a.type = this.type;
    return a;
  }
}

export class SystemAttachment {
  id: number;
  completed?: boolean;
  success?: boolean;
  progress?: number;
  progressStyle?: SafeStyle;
  url: string;
  status?: string;

  name?: string;
  type?: string;
  size?: number;

  constructor(f?: File) {
    this.name = f && f.name || '';
    this.size = f && f.size || 0;
    this.type = f && f.type || '';
    this.completed = false;
    this.success = false;
  }
}

export class NbInputItem {
  id?: number;
  value: any;
  text: string;
  css?: string;
  icon?: string;
  type?: NbFieldType;
  placeholder?: string;
  tooltip?: string;
  readonly?:boolean;
  options?:NbItemOption;
  disabled?:boolean;
  hidden?:boolean;
}
export class NbItemOption {
  text: string; // 更新字段的option文本
  value: string; // 更新字段的option值
}

export enum NbFieldType {
  // 展示类
  Index = 'index',// table:格式化为当前筛选后的编号、form:待定（TODO）
  Label = 'label', // table: 格式化为文本、form：纯文本显示，同readonly
  Array = 'array', // table: 格式化为分行文本、form：纯文本显示，同readonly（TODO）
  Calc = 'calc', // table: (TODO)、form：纯文本显示，由其他字段计算而成
  Assist = 'assist',// table:待定（TODO）、form:辅助用，不显示在页面上，但会提交
  Rating = 'rating', // table:格式化为星星、form:格式化为数字（TODO）
  Link = 'link',// table:格式化为超链接、form:待定（TODO）

  // 纯交互类
  Button = 'button', // 按钮'

  // 文本类
  Text = 'text', // table:文本、form:文本输入框
  Box = 'box' ,// table:格式化为文本、form:Area输入框
  Area = 'area' ,// table:格式化为文本、form:Area输入框
  Currency = 'currency',// table:格式化为金额、form:文本输入框格式化为金额（TODO）
  CurrencyFen = 'currencyfen',// table:格式化为金额、form:文本输入框格式化为金额，值除以100
  Number = 'number',// table:格式化为数字、form:文本输入框格式化为数字
  Html = 'html',// table:格式化为html、form:所见即所得输入（TODO）

  // 百分比类
  Progress = 'progress',// table:格式化为数字、form:slider滑动杆，-100% - 100%（TODO）
  Percentage = 'percent',// table:格式化为数字、form:文本输入框格式化为百分比（TODO）
  PercentageFen = 'percentfen',// table:格式化为数字（TODO）、form:文本输入框格式化为百分比，值除以10000

  // 文件类
  Signature = 'signature',// table:待定（TODO）、form:签名nbsign
  File = 'file',// table:格式化为文件下载连接、form:nbfile上传文件
  Image = 'image',// table:格式化为图片库、form:nbupload带预览上传
  Upload = 'upload',// table:格式化为数字、form:文本输入框格式化为数字
  Images = 'images',

  // 时间类
  Time = 'time',// table:格式化为时间日期、form:日期选择框
  Datetime = 'datetime',// table:格式化为时间日期、form:日期选择框
  Date = 'date',// table:格式化为时间日期、form:日期选择框
  Month = 'month',// table:格式化为时间日期、form:日期选择框

  // 选择项类
  Option = 'option', // table:下拉筛选、form:下拉选择框
  Massive = 'massive',// table:同option，下拉筛选框带筛选（TODO）、form:单选下拉带筛选
  Multiple = 'multiple',// table:同option，下拉筛选框带多选筛选（TODO）、form:多选下拉带筛选
  Radio = 'radio',// table:待定（TODO）、form:单选按钮组
  Checkbox = 'checkbox',// table:待定（TODO）、form:多选按钮组
  Switch = 'switch', // table: 待定（TODO）、form：显示但暂时不生效（TODO）
}

export enum NbRatingShape {
  Star = 'star',
  Bell = 'bell',
  Square = 'square',
  Circle = 'circle',
  Comment = 'comment',
  Envelope = 'envelope',
  Flag = 'flag',
  Folder = 'folder',
  Heart = 'heart',
  Hourglass = 'hourglass',
  Map = 'map',
}
